var Acr = Acr || {};

Acr.InterstitialModal = function () {
  

  var $element;
  var $documentBody;
  var $interstitialClose;
  var $interstitialBtn;

  const modalOpenClass = 'modal-open';
  const interstitialClose = '.js-interstitial-close';
  const interstitialBtn = '.js-interstitial-btn';

  function openRedirect(event) {
    $element.css('display', 'block');
    $interstitialBtn.attr('data-model-name', event.detail.model);
    $interstitialBtn.attr('data-model-year', event.detail.year);
    $interstitialBtn.attr('href', event.detail.url);
    $documentBody.addClass(modalOpenClass);
    window.Acr.TrackingManager.savePageLoadObject();
    triggerTaggingPage(event.detail.taggingJson);
  }

  function closeRedirect() {
    $element.css('display', 'none');
    $documentBody.removeClass(modalOpenClass);
    window.Acr.TrackingManager.restorePageLoadObject();
  }

  function triggerRedirect() {
    closeRedirect();
  }

  function triggerTaggingPage(trackingObject) {
    if (Acr.TrackingManager) {
      Acr.TrackingManager.pageLoad(trackingObject);
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $documentBody = $('body');
    $interstitialClose = $(interstitialClose);
    $interstitialBtn = $(interstitialBtn);
  }

  function bindEvents() {
    window.addEventListener('openInterstitialModal', openRedirect);
    $interstitialClose.click(closeRedirect);
    $interstitialBtn.click(triggerRedirect);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init,
  };
};
